import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  Home,
  Upload,
  Users,
  BookOpen,
  BarChart3,
  Bell,
  Settings,
  Menu,
  X,
  LogOut,
  
} from 'lucide-react';
import { useAuth, logout } from '../context/AuthContext';

const links = [
  { label: 'Home', to: '/home', icon: Home },
  { label: 'Upload', to: '/upload', icon: Upload },
  { label: 'Users', to: '/users', icon: Users },
  { label: 'Courses', to: '/courses', icon: BookOpen },
  { label: 'Analytics', to: '/analytics', icon: BarChart3 },
  { label: 'Notifications', to: '/notifications', icon: Bell },
  { label: 'Settings', to: '/settings', icon: Settings },
  {label: 'Modules', to:'/module', icon: BookOpen}
];

const SideNavbar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [open, setOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();

      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const NavLink = ({ to, label, Icon }) => {
    const active = pathname === to;
    return (
      <Link
        to={to}
        className={`group flex items-center gap-3 px-4 py-2.5 rounded-2xl transition-all duration-200 glass-panel ${active
            ? 'bg-white/10 text-cyan-200 shadow-glow'
            : 'hover:bg-white/5 text-slate-200 hover:text-white'
          }`}
      >
        <Icon className="h-5 w-5 text-cyan-300 group-hover:scale-110 transition-transform" />
        <span className="text-sm font-medium tracking-wide">{label}</span>
        <span className="ml-auto h-1 w-1 rounded-full bg-cyan-300/70 group-hover:scale-150 transition-transform" />
      </Link>
    );
  };

  return (
    <>
      <aside className="hidden lg:flex flex-col w-64 p-6 gap-6 bg-gradient-to-b from-slate-950/90 via-slate-950/60 to-slate-950/40 border-r border-white/5 backdrop-blur-2xl glass-panel">
        <div className="flex items-center gap-3">
          <div className="h-12 w-12 rounded-2xl bg-gradient-to-br from-neon to-cyan flex items-center justify-center text-xl font-bold text-slate-900 shadow-glow">
              <img src="/logo1.svg" alt="Logo" className="h-full w-full object-contain" />

          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-slate-400">Coded Mastery Tech.</p>
            <p className="text-lg font-semibold text-white">Admin </p>
          </div>
        </div>
        <nav className="flex flex-col gap-2">
          {links.map((item) => (
            <NavLink key={item.to} to={item.to} label={item.label} Icon={item.icon} />
          ))}
        </nav>
        <div className="mt-auto space-y-3">
         
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-2.5 rounded-2xl bg-red-500/10 hover:bg-red-500/20 text-red-200 hover:text-red-100 border border-red-500/20 transition-all duration-200"
          >
            <LogOut className="h-5 w-5" />
            <span className="text-sm font-medium tracking-wide">Sign Out</span>
          </button>
        </div>
      </aside>

      <div className="lg:hidden fixed top-4 left-4 z-50">
        <button
          onClick={() => setOpen((o) => !o)}
          className="p-3 rounded-2xl bg-white/10 border border-white/10 backdrop-blur-md text-white"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm lg:hidden" onClick={() => setOpen(false)} />
      )}

      <aside
        className={`lg:hidden fixed top-0 left-0 h-full w-72 z-50 bg-gradient-to-b from-slate-950 via-slate-900 to-slate-900 shadow-2xl transition-transform duration-300 ${open ? 'translate-x-0' : '-translate-x-full'
          }`}
      >
        <div className="p-6 flex items-center gap-3 border-b border-white/10">
          <div className="h-12 w-12 rounded-2xl bg-gradient-to-br from-neon to-cyan flex items-center justify-center text-xl font-bold text-slate-900">
            CM
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-slate-400">Coded Minds</p>
            <p className="text-lg font-semibold text-white">Admin Console</p>
          </div>
        </div>
        <div className="p-6 flex flex-col gap-3">
          {links.map((item) => (
            <NavLink key={item.to} to={item.to} label={item.label} Icon={item.icon} />
          ))}
          <button
            onClick={() => {
              handleLogout();
              setOpen(false);
            }}
            className="flex items-center gap-3 px-4 py-2.5 rounded-2xl bg-red-500/10 hover:bg-red-500/20 text-red-200 hover:text-red-100 border border-red-500/20 transition-all duration-200"
          >
            <LogOut className="h-5 w-5" />
            <span className="text-sm font-medium tracking-wide">Sign Out</span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default SideNavbar;
